import React from "react";
import "./VirasatDefaultHomePage.scss"
import bg from "../../assets/bg.jpg"
import indian from "../../assets/indian.png"
import veg from "../../assets/veg.png"
import ServiceCard from "../../components/ServiceCard/ServiceCard";
import { sortByOrderAscending } from "../../helper/helper";


const VirasatDefaultGalleryPage = ({ components }) => {
    const getHeaderComponents = (component) => {
        switch (component.ID) {
            case "VirasatDefaultGalleryPage-subheader":
                return <div className="VirasatDefaultGalleryPage-header-des">- {component?.Props?.text} -</div>
            case "VirasatDefaultGalleryPage-headertext":
                return <div className="VirasatDefaultGalleryPage-header-title">{component?.Props?.header}
                    <div className="VirasatDefaultGalleryPage-header-title-hl"> {component?.Props?.highlightedHeader}</div></div>
            default:
                return <div />
        }

    }
    const headerContent = (headerComponent) => {
        return (
            <div
                className="VirasatDefaultGalleryPage-header"
                style={{
                    backgroundImage: ` linear-gradient(90.01deg, #192233 29.22%, rgba(82, 69, 69, 0) 169.9%), url(${headerComponent?.Props?.bgSrc})`
                }}>
                <img alt="" src={headerComponent?.Props?.leftSrc} className="VirasatDefaultGalleryPage-header-indimg" />
                {sortByOrderAscending(headerComponent?.Components).map((component, key) => {
                    return (
                        getHeaderComponents(component)
                    )
                })}
                <img alt="" src={headerComponent?.Props?.rightSrc} className="VirasatDefaultGalleryPage-header-vegimg" />

            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatDefaultGalleryPage-header":
                return headerContent(component)
            case "VirasatDefaultGalleryPage-imagegrid":
                return <div className="VirasatDefaultGalleryPage-container">
                    {component?.Data?.map((img, key) => {
                        return (
                            <img alt="" src={img.src} className="VirasatDefaultGalleryPage-container-img"
                                key={key} />

                        )
                    })}
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="VirasatDefaultGalleryPage"
        >
            {sortByOrderAscending(components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}

        </div>
    )

}
export default VirasatDefaultGalleryPage